export { Button } from './Button'
export {
  Button as DeprecatedButton,
  type ButtonProps as DeprecatedButtonProps,
} from './DeprecatedButton'
